<mat-spinner *ngIf="loading | async" class="centered-spinner" mode="indeterminate"></mat-spinner>
